import React, { Suspense, lazy, useEffect } from 'react';
import './App.css';
import {
  createHashRouter,
  RouterProvider,
  useLocation,
  Outlet,
  Navigate,
} from "react-router-dom";

// Import the pages here (Home is bundled eagerly; other pages are code-split
// so the first load doesn't pull in Spline and every blog page)
import NotFoundPage from './pages/NotFoundPage';
import Home from './pages/Home';
const Research = lazy(() => import('./pages/Research'));
const Projects = lazy(() => import('./pages/Projects'));
const Blogs = lazy(() => import('./pages/Blogs'));
const Resume = lazy(() => import('./pages/Resume'));
const Hidden = lazy(() => import('./pages/Hidden'));

// Import all project pages
const Beatbounce = lazy(() => import('./pages/blog_pages/Beatbounce'));
const Forward_to_past = lazy(() => import('./pages/blog_pages/Forward_to_past'));
const Unspoken = lazy(() => import('./pages/blog_pages/Unspoken'));
const FridayHarbor = lazy(() => import('./pages/blog_pages/friday_harbor'));
const XRCooking = lazy(() => import('./pages/blog_pages/XR_cooking'));
const RidewithgpsMcp = lazy(() => import('./pages/blog_pages/RidewithgpsMcp'));
const XR_association = lazy(() => import('./pages/blog_pages/XR_association'));
const CSF_justice = lazy(() => import('./pages/blog_pages/CSF_justice'));
const Maps = lazy(() => import('./pages/blog_pages/Maps'));
const AR_health_tracking = lazy(() => import('./pages/blog_pages/AR_health_tracking'));

// ScrollToTop component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Layout component to include ScrollToTop
const Layout = () => (
  <>
    <ScrollToTop />
    <Suspense fallback={null}>
      <Outlet />
    </Suspense>
  </>
);

const router = createHashRouter([
  {
    element: <Layout />, // Add the layout with ScrollToTop here
    errorElement: <NotFoundPage />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/publications",
        element: <Navigate to="/research" replace />,
      },
      {
        path: "/research",
        element: <Research />,
      },
      {
        path: "/projects",
        element: <Projects />,
      },
      {
        path: "/blog",
        element: <Blogs />,
      },
      {
        path: "/resume",
        element: <Resume />,
      },
      {
        path: "/hidden",
        element: <Hidden />,
      },
      {
        path: "/beatbounce",
        element: <Beatbounce />,
      },
      {
        path: "/forward-to-past",
        element: <Forward_to_past />,
      },
      {
        path: "/xr-cooking-capstone",
        element: <XRCooking />,
      },
      {
        path: "/unspoken",
        element: <Unspoken />,
      },
      {
        path: "/friday-harbor-2024",
        element: <FridayHarbor />,
      },
      {
        path: "/ridewithgps-mcp",
        element: <RidewithgpsMcp />,
      },
      {
        path: "/xr-association",
        element: <XR_association />,
      },
      {
        path: "/csf-justice",
        element: <CSF_justice />,
      },
      {
        path: "/maps",
        element: <Maps />,
      },
      {
        path: "/ar-health-tracking",
        element: <AR_health_tracking />,
      },
    ],
  },
]);

export default class App extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <RouterProvider router={router} />;
  }
}
